module.exports = __webpack_public_path__ + "static/media/educationArticle1.4660a10c.jpg";